export default {
  nnnowLogoUrl:
    "https://cdn02.nnnow.com/web-images/master/navtree_metaData/59b2425ae4b0d70964ee66e0/1505806763887/12NNNOWLOGODESKTOP.png",
  nnnowMobileLogo:
    "https://static.nnnow.com/client/assets/images/nnnow-logo-beta_1.png",
  nnnowBaseUrl: "https://odin-qa.ailiens.com/",
  gmailLogo:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/google-social-login.svg",
  fbLogo:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/facebook.png",
  sadFaceLogo:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/sad_face.png",
  googleMapsUrl: "//maps.google.com/maps?z=12&t=m&q=",
  noImg:
    "https://static.nnnow.com/client/assets/images/icon/defaultSkuImage.png",
  fpImage:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/Forgot+password+(1).png",
  missedImage:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/phone-number.png",
  resetImage:
    "https://s3-ap-southeast-1.amazonaws.com/web-resources-odin/reset_password.png",
  brush_stroke: "https://static.nnnow.com/brush-stroke.png",
};



// WEBPACK FOOTER //
// ./src/api/endPoints/staticEndpoints.js